import {
  Backdrop,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";
import { common_axios } from "../../../../App";
import Loader from "../../../../components/Loader";
import PersonIcon from "@mui/icons-material/Person";
import InfoIcon from "@mui/icons-material/Info";
import Swal from "sweetalert2";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import SystemTpsss from "../../../../assets/images/s tps-01.svg";
export default function SystemTps() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const [data, setData] = useState([]);
  const [open, setOpen] = useState();
  const [maxLimit, setMaxLimit] = useState();
  const [tpsLimit, setTpsLimit] = useState();
  const [hideSkeleton1, setHideSkeleton1] = useState();

  // console.log("first",maxLimit)

  // .....................................Formik............................................//
  const initialValues = {
    systemTpsModel: undefined,
  };

  const validationSchema = yup.object({
    systemTpsModel: yup
      .string()
      //    .min(8, "Minimum length of a mobile number is 8 digits")
      //    .max(8, "Maximum length of mobile number is 8 digits")
      .required("Required"),
  });
  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      TpsUpdate(values);
    },
  });
//   console.log("jooiiuu",formik?.values?.systemTpsModel)
  //  ..................................TPS Get API..................................................//

  async function TpsGet() {
    setData([]);
    setHideSkeleton1(true);

    try {
      // setOpen(true);

      const result = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/system-tps`
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        
        await setMaxLimit(result.data.systemTpsModel);
        await formik.setFieldValue("systemTpsModel", result.data.systemTpsModel.tpsLimit);
        setHideSkeleton1(false);
      } else {
        // setOpen();
        setHideSkeleton1(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      // setOpen();
      setHideSkeleton1(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    TpsGet();
  }, []);
  //  ..................................TPS Update API..................................................//
  async function TpsUpdate(values) {
    // event.preventDefault()
    setData([]);
    try {
      setOpen(true);

      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/update/system/tps`,
        {
          username: localStorage.getItem("usernamedisplayed"),
          id: maxLimit.id,
          tpsLimit: values.systemTpsModel,
          //   pageSize: TableStatus?.pageSize,
        }
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        localStorage.setItem("TpsControlLimit",formik.values.systemTpsModel)

        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
        // await setData1(result.data.fileUploads);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  //   ...............................................................................................//

  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const modelButtonApprove1 = useRef(null);

  const approveUserModal1 = async (cell) => {
    // console.log(cell.row.original);

    await modelButtonApprove1.current.click();
    await setSelectedUserDetailApprove(cell.row.original);
  };


  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <form
          onSubmit={formik.handleSubmit}
          className="row g-3 needs-validation"
          novalidate
        >
          <div>
            <button
              ref={modelButtonApprove1}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdrop1Label"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdrop1Label">
                      {/* Are you sure you want to update? */}
                      Are you sure
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        //   setSelectedUserDetailApprove(null);
                      }}
                    ></button>
                  </div>

                  <div className="modal-body"></div>

                  <div className="modal-footer justify-content-between">
                    <button
                      type="button"
                      id="close_edit1"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        //   setSelectedUserDetailApprove(null);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        // TpsUpdate();
                      }}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* )} */}

          <ThemeProvider theme={theme}>
            <div className="container-fluid">
              <div className="card">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                    {/* <PersonIcon
                      style={{
                        color: "white",
                        fontSize: "27px",
                      }}
                    /> */}
                    <img src={SystemTpsss} class="img-fluid d-block m-auto" style={{width:'40px',}}/>
                

                  </div>
                  <div className="pt-1">
                    <p
                      className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                      style={{ marginLeft: "70px" }}
                    >
                      System TPS
                    </p>
                    <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                      Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div>
                </div>
                <div className="card-body mt-4">
                  <div className="card shadow-none border bg_blue">
                    <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                      System TPS
                    </span>

                    <div
                      className="row card-body text-lg-start text-center "
                      id="ip_button"
                    >
                      {hideSkeleton1 == true ? (
                        <>
                          <Box sx={{ width: "25%" }}>
                            <Skeleton />
                            <Skeleton animation="wave" />
                            {/* <Skeleton animation={false} /> */}
                          </Box>
                        </>
                      ) : (
                        <>
                          <div className="col-md-3" id="tool_tip">
                            <TextField
                              required
                              className="w-100"
                              label="TPS Limit"
                              name="systemTpsModel"
                              variant="outlined"
                              size="small"
                              type="number"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Tooltip
                                      title="TPS Limit"
                                      placement="top"
                                      arrow
                                      sx={{ color: "#85CBF2" }}
                                    >
                                      <InfoIcon />
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              }}
                              value={
                                  formik.values.systemTpsModel 
                              }
                              // helperText={
                              //   Number(formik.values?.tpsLimit) >
                              //   Number(maxLimit?.maxTpsLimit) ? (
                              //     <span style={{ color: "red" }}>
                              //       TPS Limit should be Less than or equal to
                              //       Maximum TPS Limit
                              //     </span>
                              //   ) : null
                              // }


                              onChange={formik.handleChange}
                              error={
                                formik.touched.tpsLimit &&
                                Boolean(formik.errors.tpsLimit)
                              }
                                        helperText={
                                          formik.touched.tpsLimit &&
                                          formik.errors.tpsLimit
                                        }
                             
                              //     onInput={(e) => {

                              //   e.target.value = e.target.value.slice(0, 8);
                              // }}
                              // onInput={(e) => {
                               

                              //   e.target.value = e.target.value.slice(
                              //     0,
                              //     maxLimit?.maxTpsLimit.toString().length
                              //   );
                              // }}
                              // helperText={formik.touched.tpsLimit && formik.errors.tpsLimit}
                            />
                          </div>
                        </>
                      )}

                      {/* {hideSkeleton1 == true ? (
                        <>
                          <Box sx={{ width: "25%" }}>
                            <Skeleton />
                            <Skeleton animation="wave" />
                            
                          </Box>
                        </>
                      ) : (
                        <>
                          <div className="col-md-3 imp_up">
                            <TextField
                              className="w-100"
                              label="Maximum TPS Limit"
                              name="maxTpsLimit"
                              variant="outlined"
                              disabled
                              size="small"
                              type="text"
                              value={
                                maxLimit?.maxTpsLimit != null
                                  ? maxLimit?.maxTpsLimit
                                  : null
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Tooltip
                                      title="Maximum TPS Limit"
                                      placement="top"
                                      arrow
                                      sx={{ color: "#85CBF2" }}
                                    >
                                      <InfoIcon />
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              }}

                            
                            />
                          </div>
                        </>
                      )} */}

                      <div className="col-md-3">
                        <button
                          type="button"
                          // disabled={
                          //   formik.values.tpsLimit == undefined ||
                          //   formik.values.tpsLimit == ""
                          // }
                          className="btn green_UP btn_SIZE w_btn m-0 ms-3 btn_w8"
                          onClick={approveUserModal1}
                        >
                          Update
                          {/* <AddRoundedIcon style={{ fontSize: "19px" }} /> */}
                        </button>

                        {/* <button
                          onClick={formik.resetForm}
                          type="button"
                          className="btn resetBtn_UP m-0 ms-3 w_btn btn_w8 btnReset btn_SIZE"
                        >
                          Reset
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ThemeProvider>
        </form>
      </main>
    </>
  );
}
